module.exports = __webpack_public_path__ + "./img/4364ec9b877ca259e35a33bab2e6923f.png";